import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { getCollectionQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/collectionKeys.js';
import { WEB_VERSION } from '#pplx/frontend/components/utils/consts.js';
import { isCollectionAccessDeniedErrorCode } from '#pplx/frontend/components/utils/PrivacyUtils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { collectionsClient } from '#pplx_generated/typespec/rest/collections/client.js';
export const getCollectionQueryOptions = ({ collectionSlug, reason, }) => ({
    queryKey: getCollectionQueryKey(collectionSlug ?? ''),
    queryFn: async () => {
        if (!collectionSlug)
            return null;
        return getCollection({
            params: {
                collection_slug: collectionSlug,
                version: WEB_VERSION,
            },
            reason,
        });
    },
});
export const getCollection = async ({ headers = {}, params, reason, }) => {
    try {
        const { data, error, response } = await collectionsClient.GET(`/rest/collections/get_collection`, reason, {
            params: {
                query: params,
            },
            headers,
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to get collection',
                cause: error,
                status: response.status ?? 0,
            });
        }
        if (!data?.status || data?.status === 'failed') {
            const errorCode = data && typeof data === 'object' && 'error_code' in data
                ? String(data.error_code)
                : undefined;
            if (isCollectionAccessDeniedErrorCode(errorCode)) {
                return { collection: undefined, errorCode };
            }
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to get collection',
                cause: data,
                status: response.status ?? 0,
            });
        }
        return {
            collection: data,
            errorCode: undefined,
        };
    }
    catch (err) {
        logger.error(err);
        return { collection: undefined, errorCode: undefined };
    }
};
//# sourceMappingURL=getCollection.js.map